// @flow

import { getIntersectionObserverRootMargin } from 'app/common/react/components/video/utils/videoUtils';
import { type Resolution } from 'app/common/react/components/PinRep/components/PinVisual/PinVisual';
import { type Surface } from 'app/common/react/components/PinRep/core/PinRepConfiguration';
import {
  DEPRECATED_PRODUCT_PINREP_WIDTH,
  PRODUCT_PINREP_WIDTH,
  UPDATED_PRODUCT_PINREP_WIDTH,
} from 'app/common/react/components/shopping/ProductPin/consts';

type BuildPinVisualPropsArgs = {|
  allowImageCropping?: boolean,
  hasCarouselData: boolean,
  isSocialSeasonalBoard: boolean,
  resolution?: Resolution,
  showPromotedVideos: boolean,
  surface?: Surface,
|};

export type BuildPinVisualPropsOutput = {|
  allowImageCropping: boolean,
  // Crop image if it's a related product pin in closeup
  cropProductPinWidth?: number,
  isSocialSeasonalBoard: boolean,
  resolution: Resolution,
  rootMargin?: string,
  showCarousel: boolean,
  // Should we show promoted videos (vs an image, experiment 'ads_desktop_video_ads')
  showPromotedVideos: boolean,
|};

export default function buildPinVisualProps({
  allowImageCropping = true,
  hasCarouselData,
  isSocialSeasonalBoard,
  resolution = 'default',
  showPromotedVideos,
  surface,
}: BuildPinVisualPropsArgs): BuildPinVisualPropsOutput {
  let cropProductPinWidth;
  if (surface === 'CloseupRelatedProducts') {
    cropProductPinWidth = PRODUCT_PINREP_WIDTH;
  } else if (surface === 'BrioCloseupRelatedProducts') {
    cropProductPinWidth = DEPRECATED_PRODUCT_PINREP_WIDTH;
  } else if (surface === 'UpdatedCloseupRelatedProducts') {
    cropProductPinWidth = UPDATED_PRODUCT_PINREP_WIDTH;
  }

  // This is the rootMargin used for intersection observers.
  const rootMargin = getIntersectionObserverRootMargin(surface);

  return {
    allowImageCropping,
    cropProductPinWidth,
    isSocialSeasonalBoard,
    resolution,
    rootMargin,
    showCarousel: hasCarouselData,
    showPromotedVideos,
  };
}
